/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Usage } from 'cio/utils/subscription-topic-usage';
import { CampaignState } from 'cio/models/campaign';
import { SendStateType } from 'cio/models/newsletter';

const VIEW_ALL_ROUTES = {
  campaign: 'campaigns.index',
  newsletter: 'broadcasts.list.newsletters.index',
  broadcast: 'broadcasts.list.api-triggered.index',
};

const ITEM_ROUTES = {
  campaign: 'campaigns.campaign',
  newsletter: 'broadcasts.newsletter',
  broadcast: 'broadcasts.broadcast',
};

interface UsageComponentArgs {
  title: string;
  topicID: string;
  items: Usage[];
  type: 'campaign' | 'newsletter' | 'broadcast';
}

export default class UsageComponent extends Component<UsageComponentArgs> {
  get lastUpdatedItems() {
    return [...this.args.items]
      .sort((a: Usage, b: Usage) => b.updated - a.updated)
      .slice(0, 4)
      .map((item) => ({
        ...item,
        sendState: this.convertToNewsletterState(item.state),
      }));
  }

  private convertToNewsletterState(state: CampaignState | SendStateType) {
    if (state === CampaignState.Draft) {
      return 'drafted';
    }
    return state;
  }

  get itemRoute() {
    return ITEM_ROUTES[this.args.type];
  }

  get viewAllRoute() {
    return VIEW_ALL_ROUTES[this.args.type];
  }

  get viewAllQuery() {
    if (this.args.type === 'newsletter') {
      return {
        subscriptionTopicId: this.args.topicID,
        type: 'scheduled',
      };
    }

    return {
      subscriptionTopicId: this.args.topicID,
      state: CampaignState.Running,
    };
  }
}
